module.exports = __webpack_public_path__ + "static/media/07.446f1c2d.jpg";